import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import DateInput from '../Common/DateInput'
import SelectForm from '../Common/SelectForm'
import SelectFormSort from '../Common/SelectFromSort'
import {EDUCATIONS_PM, NUMBER_YEAR_PRACTIVE, CERTIFICATIONS_DESIGNER, CERTIFICATIONS_DESIGNER_FULL} from '../../data/config'
import UploadListImage from '../Common/UploadListImage'
import MultiSelect from 'react-select'

class Pm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pmDetail: {}
        }
    }

    componentWillMount = () => {
        this.getPmDetail(this.props.vendor._id);
    }

    getPmDetail = (vendor) => {
        do_action('get_pm_detail', { vendor })
            .then(data => {
                if (data.signal) {
                    this.setState({
                        pmDetail: data.data
                    });
                }
            })
            .catch(err => console.log(err));
    }

    handleChangeSelect = (name, value) => {
        let { pmDetail } = this.state
        pmDetail[name] = value
        this.setState({ pmDetail })
        this.props.updateForm(name, value)
    }

    changeInput = (property, e) => {
        this.props.updateForm(property, e.target.value);
        let { pmDetail } = this.state;
        pmDetail[property] = e.target.value;
        this.setState({ pmDetail });
    }

    changeDate(value, key) {
        try {
            let time = value.format('DD/MM/YYYY')
            let { pmDetail } = this.state
            pmDetail[key] = time
            this.setState({ pmDetail })
            this.props.updateForm(key, time)
        } catch (err) {
            console.log(err)
        }
    }

    handleChangeMultiSelect = (e) => {
        let array = e.map(item => {
            return item.value
        })
        array = array.join();
        let { pmDetail } = this.state;
        pmDetail['certifications_others'] = array;
        this.setState({
            pmDetail
        })
        let name = 'certifications_others'
        this.props.updateForm(name, array)
    }

    updateImage = (list_image) => {
        let { pmDetail } = this.state
        pmDetail.list_image = list_image
        this.setState({ pmDetail })
        this.props.updateForm('list_image', list_image)
    }

    render() {
        let { pmDetail } = this.state;
        if (!pmDetail._id) return ''

        let list_image = pmDetail.list_image ? JSON.parse(pmDetail.list_image) : []

        let certifications = pmDetail.certifications_others.split(",");

        let options = certifications.map((item, index) => {
            return {
                value: item,
                label: item,
            }
        })

        return (
            <div>
                <p className="tit fontMedium">Excerpt</p>
                <div className="form-group">
                    <textarea value={pmDetail.excerpt ? pmDetail.excerpt : ''} row={3} onChange={this.changeInput.bind(this, 'excerpt')} className="form-control form-control-mix" />
                </div>
                <p className="tit fontMedium">Date Of registration</p>
                <div className="form-group">
                    <DateInput timeInput={pmDetail.date_of_regis ? pmDetail.date_of_regis : ''} name="date_of_regis" changeDate={this.changeDate.bind(this)}/>
                </div>
                <p className="tit fontMedium">Name of project manager</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.name_of_project_manager ? pmDetail.name_of_project_manager : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'name_of_project_manager')} readOnly={true}/>
                </div>
                <p className="tit fontMedium">Nationality</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.nationality ? pmDetail.nationality : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'nationality')} />
                </div>

                <p className="tit fontMedium">Education</p>
                <SelectForm 
                    name="education" 
                    value={pmDetail.education ? pmDetail.education : ''} 
                    data={EDUCATIONS_PM} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Principal activity 2</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.principal_activity_2 ? pmDetail.principal_activity_2 : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'principal_activity_2')} />
                </div>

                <p className="tit fontMedium">No. of yrs in practice</p>
                <SelectFormSort 
                    name="no_of_yrs_in_practice" 
                    value={pmDetail.no_of_yrs_in_practice ? pmDetail.no_of_yrs_in_practice : ''} 
                    data={NUMBER_YEAR_PRACTIVE} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Litigation (Local/PR)</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.litigation_local_pr ? pmDetail.litigation_local_pr : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'litigation_local_pr')} />
                </div>
                <p className="tit fontMedium">BANKRUPTCY/ WINDING UP (Local/PR)</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.bankruptcy_winding_up_local_pr ? pmDetail.bankruptcy_winding_up_local_pr : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'bankruptcy_winding_up_local_pr')} />
                </div>

                <p className="tit fontMedium">Past Criminal Records</p>
                <SelectForm 
                    name="past_criminal_records" 
                    value={pmDetail.past_criminal_records ? pmDetail.past_criminal_records : ''} 
                    data={['Yes', 'No', 'Not Declaring']} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Pending Police Investigation</p>
                <SelectForm 
                    name="pending_police_investigation" 
                    value={pmDetail.pending_police_investigation ? pmDetail.pending_police_investigation : ''} 
                    data={['Yes', 'No', 'Not Declaring']} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Pending Legal Case (Defendant)</p>
                <SelectForm 
                    name="pending_legal_case_defendant" 
                    value={pmDetail.pending_legal_case_defendant ? pmDetail.pending_legal_case_defendant : ''} 
                    data={['Yes', 'No', 'Not Declaring']} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Project Portfolio</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.project_portfolio ? pmDetail.project_portfolio : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'project_portfolio')} />
                </div>

                <p className="tit fontMedium">Certifications (Others)</p>
                {/* <SelectForm 
                    name="certifications_others" 
                    value={pmDetail.certifications_others ? pmDetail.certifications_others : ''} 
                    data={CERTIFICATIONS_DESIGNER} 
                    onChange={this.handleChangeSelect.bind(this)} 
                /> */}
                <MultiSelect
                    value={options}
                    isMulti
                    name="certifications_others"
                    options={CERTIFICATIONS_DESIGNER_FULL}
                    className="basic-multi-select"
                    classNamePrefix="select"
                    onChange={this.handleChangeMultiSelect.bind(this)}
                />

                <p className="tit fontMedium">Awards</p>
                <SelectForm 
                    name="awards" 
                    value={pmDetail.awards ? pmDetail.awards : ''} 
                    data={['IDEA', 'Others']} 
                    onChange={this.handleChangeSelect.bind(this)} 
                />

                <p className="tit fontMedium">Past Client References</p>
                <div className="form-group">
                    <input type="text" value={pmDetail.past_client_references ? pmDetail.past_client_references : ''} className="form-control form-control-mix" onChange={this.changeInput.bind(this, 'past_client_references')} />
                </div>
                <p className="tit fontMedium">List Image</p>
                <div className="form-group">
                    <UploadListImage 
                        image={list_image}
                        updateImage={this.updateImage}
                    />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(Pm);